import styled from 'styled-components';

export const JobName = styled.p`
  color: var(--color-text);
  font-size: 20px;
  font-weight: 600;
  margin: 4px 0 0;
`;
